export default __webpack_public_path__ + "static/media/1-logos-backend.a678774c.png";